"use client";

import Magnetic from "@/components/ui/Magnetic";
import { Send } from "lucide-react";
import Link from "next/link";

export default function CareerCTA() {
    return (
        <section className="py-32 bg-black text-white relative overflow-hidden">
            {/* Subtle background element */}
            <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-blue-500/10 blur-[120px] rounded-full"></div>
            <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/2 w-96 h-96 bg-purple-500/10 blur-[120px] rounded-full"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
                <h2 className="text-5xl md:text-7xl font-bold mb-8 tracking-tighter uppercase italic">
                    Don&apos;t see a <br />perfect fit?
                </h2>
                <p className="text-xl md:text-2xl mb-12 max-w-2xl mx-auto text-gray-400 font-medium">
                    We&apos;re always looking for elite talent to join our mission. Send us your profile for an open application, and let&apos;s build the future of AI together.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                    <Magnetic strength={0.2}>
                        <Link
                            href="/contact#careers"
                            className="px-8 py-4 bg-white text-black text-lg font-bold uppercase tracking-wider hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center space-x-2 rounded-full"
                        >
                            <span>Open Application</span>
                            <Send className="h-5 w-5" />
                        </Link>
                    </Magnetic>
                </div>
            </div>
        </section>
    );
}
